import Modal from "./index";

const ProofOfResidenceModal = ({
  showProofOfResidenceModal,
  setShowProofOfResidenceModal,
  handleDocumentChange,
  handleDocumentUpload,
  handleChange,
  documentType,
  active,
  isProcessing,
}) => {
  const proofOfResidence = documentType.filter(function (value) {
    return value.id === 32;
  });
  return (
    <Modal
      openModal={showProofOfResidenceModal}
      setOpenModal={setShowProofOfResidenceModal}
    >
      <button
        type="button"
        className="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
        onClick={() => {
          setShowProofOfResidenceModal(false);
        }}
      ></button>

      <h2 className="fw-bold text-center mb-1" id="documentModel">
        Upload Document
      </h2>

      <p className="fs-lg text-center text-muted mb-6 mb-md-8">
        Proof of Residence
      </p>

      <div className="card-body">
        <div className="form-group fallback">
          <div className="custom-file">
            <input
              className="form-control"
              id="documentUpload"
              type="file"
              onChange={handleDocumentChange}
            />
          </div>
        </div>

        <div className="form-group ">
          <label className="form-label" htmlFor="documentType">
            Document Type
          </label>
          <select
            className="form-select"
            id="documentID"
            onChange={handleChange}
          >
            <option value="">---select document---</option>
            {proofOfResidence.map((document) => (
              <option value={document.id} key={document.id}>
                {document.name}
              </option>
            ))}
          </select>
        </div>

        <div className="row">
          <div className="col-12 col-md-auto">
            <button
              className="btn w-100 btn-primary"
              type="submit"
              disabled={!active || isProcessing}
              onClick={handleDocumentUpload}
            >
              {isProcessing ? <>Saving ...</> : <>Save Document</>}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ProofOfResidenceModal;
